import React from "react";
import PropTypes from "prop-types";
import Moment from "react-moment";
import ReactInterval from "react-interval";
// import material-ui components
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/styles"
import TablePagination from "@material-ui/core/TablePagination";
// import material-ui icons
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import MoreIcon from "@material-ui/icons/MoreHoriz";
//redux components
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
//import core components
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Table from "components/Table/Table.jsx";
import ConfirmDeleteDialog from "components/Dialogs/ConfirmDeleteDialog";
import KeyDialog from "components/Dialogs/KeyDialog";
import PhoneNumber from "components/NumberPrettifier/NumberPrettifier";
import SuccessDialog from "components/Dialogs/SuccessDialog";
import ErrorDialog from "components/Dialogs/ErrorDialog";
import CustomInput from "components/CustomInput/CustomInput";

import * as actionCreators from "actions/keys";

import usersStyle from "assets/jss/material-dashboard-react/views/usersStyle"
import {history} from "../../history";
import { roles } from "utils/misc";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

function mapStateToProps(state) {
    return {
        token: state.auth.token,
        invalidKeys: state.keys.invalidKeys,
        keys: state.keys.keys,
        keyTypesIsLoaded: state.keys.key_types.isLoaded,
        keyTypes: state.keys.key_types.data,
        role: state.auth.role,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

class KeysView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invalidKeysData: [],
            keysData: [],
            timeoutEnabled: false,
            keyDialogIsOpened: false,
            keyDialogIsNew: false,
            keyDialogData: null,
            deleteKeyDialogIsOpened: false,
            deleteKeyId: null,
            keysRowsPerPage: 25,
            keysPage: 1,
            keyFilterType: "",
            invalidKeysRowsPerPage: 25,
            invalidKeysPage: 1,
            successDialogIsOpened: false,
            errorDialogIsOpened: false,
            search_query: "",
        };
    }

    componentWillReceiveProps(nextProps, nextContext){
        const { classes } = nextProps;
        this.setState((prevState) => ({
            ...prevState,
            invalidKeysData: nextProps.invalidKeys.isLoaded  ? nextProps.invalidKeys.data.map((prop) => (
                [prop.id, <span className={classes.keyHashSpan}>{prop.key_hash}</span>, `${prop.machine_id},
                ${prop.machine_address}`,
                    (<Moment format="DD/MM/YYYY HH:mm:ss" date={prop.time}/>),
                    (<Button justIcon round simple color="transparent" className={classes.tableButton}
                             onClick={() => this.keyDialogOpen(null, prop.key_hash)}
                    >
                        <AddIcon/>
                    </Button>)]
            )) : prevState.invalidKeysData,
            keysData: nextProps.keys.isLoaded ? nextProps.keys.data.map((prop) => (
                [prop.id, <span className={classes.keyHashSpan}>{prop.key_hash}</span>, prop.name, prop.type,
                    prop.balance, prop.organization,
                    (<PhoneNumber number={prop.phone}/>),
                    (<div>
                        <Button justIcon round simple color="transparent" className={classes.tableButton}
                                onClick={() => KeysView.redirectToKeyPage(prop.id)}
                                disabled={this.props.role === roles[5]}
                        >
                            <MoreIcon/>
                        </Button>
                        <Button justIcon round simple color="transparent" className={classes.tableButton}
                                onClick={() => this.keyDialogOpen(prop.id)}
                                disabled={this.props.role === roles[5]}
                        >
                            <EditIcon/>
                        </Button>
                        <Button justIcon round simple color="danger"  className={classes.tableButton}
                                onClick={() => this.deleteKeyDialogOpen(prop.id)}
                                disabled={this.props.role === roles[5]}
                        >
                            <DeleteIcon/>
                        </Button>
                    </div>)]
            )) : prevState.keysData
        }))
    }

    componentDidMount(){
        this.setState({
            timeoutEnabled: true,
        });
        this.getData();
    }

    componentWillUnmount(){
        this.setState({
            timeoutEnabled: false,
        })
    }

    getData(){
        this.props.getInvalidKeys(this.props.token, this.state.invalidKeysPage, this.state.invalidKeysRowsPerPage);
        this.props.getKeys(this.props.token, this.state.keysPage, this.state.keysRowsPerPage, this.state.search_query,
            this.state.keyFilterType);
        this.props.getKeyTypes(this.props.token);
    }

    deleteKeyDialogOpen(id){
        this.setState({
            deleteKeyDialogIsOpened: true,
            deleteKeyId: id,
        })
    }

    deleteKeyDialogClose(){
        this.setState({
            deleteKeyDialogIsOpened: false,
            deleteKeyId: null,
        })
    }



    deleteKey(){
        this.deleteKeyDialogClose();
        this.state.deleteKeyId && this.props.deleteKey(this.props.token, this.state.deleteKeyId)
            .then(r => {typeof r !== typeof undefined? this.successDialogShow(): this.errorDialogOpen()});
        this.setState({
            deleteKeyId: null,
        }, this.getData)
    }

    keyDialogOpen(keyId, keyHash){
        if (typeof keyHash === "undefined") {
            this.setState({
                keyDialogIsOpened: true,
                keyDialogIsNew: !keyId,
                keyDialogData: (keyId && this.props.keys.isLoaded) ? this.props.keys.data.map((key) => (key.id === keyId ? key : null)).filter(n => n)[0] : null,
            })
        } else {
            console.log("from und");
            this.setState({
                keyDialogIsOpened: true,
                keyDialogIsNew: true,
                keyDialogData: {key_hash: keyHash},
            })
        }
    }

    keyDialogClose(){
        this.setState({
            keyDialogIsOpened: false,
            keyDialogData: null,
        })
    }

    saveKey(key){
        if (!this.state.keyDialogIsNew) {
            this.props.editKey(this.props.token, key).then(r => {typeof r !== typeof undefined ? this.successDialogShow(): this.errorDialogOpen()})
        } else {
            this.props.createKey(this.props.token, key).then(r => {typeof r !== typeof undefined ? this.successDialogShow(): this.errorDialogOpen()})
        }
        this.keyDialogClose();
        this.getData();
    }

    handleKeysChangePage(page){
        this.setState({
            keysPage: page
        }, this.getData)
    }

    handleKeysChangeRowsPerPage(e){
        if (e.target.value !== this.state.keysRowsPerPage) {
            this.setState({
                keysRowsPerPage: e.target.value
            }, this.getData);
        }
    }

    handleInvalidKeysChangePage(page){
        this.setState({
            invalidKeysPage: page
        }, this.getData)
    }

    handleInvalidKeysChangeRowsPerPage(e){
        if (e.target.value !== this.state.invalidKeysRowsPerPage) {
            this.setState({
                invalidKeysRowsPerPage: e.target.value
            }, this.getData);
        }
    }

    static redirectToKeyPage(id){
        history.push(`/keys/${id}/`)
    }

    successDialogShow(){
        this.setState({
            successDialogIsOpened: true,
        })
    }

    successDialogClose(){
        this.setState({
            successDialogIsOpened: false,
        })
    }

    errorDialogOpen(){
        this.setState({
            errorDialogIsOpened: true,
        })
    }

    errorDialogClose(){
        this.setState({
            errorDialogIsOpened: false,
        })
    }

    _changeValue(e, type) {
        const value = e.target.value;
        const next_state = {};
        next_state[type] = value;
        this.setState(next_state, this.getData);
    }

    render(){
        const { classes } = this.props;
        return (
            <div>
                <Card>
                    <CardHeader color="warning">
                        <Grid container>
                            <GridItem xs={6} s={10} md={10}>
                                <h4>Ключи</h4>
                            </GridItem>
                            <GridItem xs={6} s={2} md={2}>
                                <Button color="warning" className={classes.headerButton} onClick={() => this.keyDialogOpen()}>
                                    <AddIcon className={classes.icons}/>Новый
                                </Button>
                            </GridItem>
                        </Grid>
                    </CardHeader>
                    <CardBody>
                        <CustomInput
                            labelText="Поиск по ключам"
                            formControlProps={{
                                className: classes.keySearchInput,
                                fullWidth: false
                            }}
                            inputProps={{
                                value: this.state.search_query,
                                onChange: e => this._changeValue(e, "search_query")
                            }}
                        />
                        <FormControl className={classes.selectWrapper}>
                            <InputLabel>Тип</InputLabel>
                            <Select
                                value={this.state.keyFilterType}
                                onChange={(e) => this._changeValue(e, "keyFilterType")}
                                inputProps={{
                                    name: 'keyFilterType',
                                }}
                                className={classes.select}
                            >
                                <MenuItem value=""><em>Все</em></MenuItem>
                                {this.props.keyTypes.map((type, id) => (
                                    <MenuItem key={id} value={type.id}>{type.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Table
                            tableHead={["ID", "HEX", "Имя", "Тип", "Баланс", "Организация", "Телефон", ""]}
                            tableData={this.state.keysData}
                            tablePagination={(<TablePagination count={this.props.keys.count || 0}
                                                           onChangePage={(e, page) => this.handleKeysChangePage(page + 1)}
                                                           page={this.state.keysPage - 1} rowsPerPage={this.state.keysRowsPerPage}
                                                           labelDisplayedRows={({from, to, count}) => `${from}-${to} из ${count}`}
                                                           labelRowsPerPage="Строк на страницу:" component="div"
                                                           onChangeRowsPerPage={(e) => this.handleKeysChangeRowsPerPage(e)}
                            />)}
                        />
                    </CardBody>
                    <KeyDialog isOpened={this.state.keyDialogIsOpened} onSave={(key) => this.saveKey(key)}
                               onCancel={() => this.keyDialogClose()} isNew={this.state.keyDialogIsNew}
                               keyData={this.state.keyDialogData} types={this.props.keyTypes}
                               role={this.props.role}
                    />
                    <ConfirmDeleteDialog onCancel={() => this.deleteKeyDialogClose()} onSave={() => this.deleteKey()}
                                         isOpened={this.state.deleteKeyDialogIsOpened}
                                         bodyText="Вы точно хотите удалить данный ключ? Это действие нельзя будет отменить."
                    />
                </Card>
                <Card>
                    <CardHeader color="primary">
                        <h4>Нераспознанные ключи</h4>
                    </CardHeader>
                    <CardBody>
                        <Table
                            tableHead={["ID", "Хэш ключа", "Аппарат", "Время", ""]}
                            tableData={this.state.invalidKeysData}
                            tablePagination={(<TablePagination count={this.props.invalidKeys.count || 0}
                                                           onChangePage={(e, page) => this.handleInvalidKeysChangePage(page + 1)}
                                                           page={this.state.invalidKeysPage - 1} rowsPerPage={this.state.invalidKeysRowsPerPage}
                                                           labelDisplayedRows={({from, to, count}) => `${from}-${to} из ${count}`}
                                                           labelRowsPerPage="Строк на страницу:" component="div"
                                                           onChangeRowsPerPage={(e) => this.handleInvalidKeysChangeRowsPerPage(e)}
                            />)}
                        />
                    </CardBody>
                </Card>
                <SuccessDialog onClose={() => this.successDialogClose()} isOpened={this.state.successDialogIsOpened}/>
                <ErrorDialog onClose={() => this.errorDialogClose()} isOpened={this.state.errorDialogIsOpened}/>
                <ReactInterval timeout={15000} enabled={this.state.timeoutEnabled} callback={() => this.getData()}/>
            </div>
        )
    }
}

KeysView.propTypes = {
    getInvalidKeys: PropTypes.func,
    getKeys: PropTypes.func,
    createKey: PropTypes.func,
    editKey: PropTypes.func,
    deleteKey: PropTypes.func,
    getKeyTypes: PropTypes.func,
    token: PropTypes.string,
    invalidKeys: PropTypes.array,
    keys: PropTypes.shape({
        isLoading: PropTypes.bool,
        isLoaded: PropTypes.bool,
        data: PropTypes.array,
        count: PropTypes.number,
        pages: PropTypes.number,
        page: PropTypes.number,
    }),
    keyTypes: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(usersStyle)(KeysView));


// WEBPACK FOOTER //
// ./src/views/Keys/Keys.jsx